var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as ed25519 from 'noble-ed25519';
import rsaOperations from 'keystore-idb/rsa';
import utils from 'keystore-idb/utils';
import aes from 'keystore-idb/aes';
import { CharSize, SymmKeyLength } from 'keystore-idb/types';
import { assertBrowser } from '../common/browser';
import * as keystore from '../keystore';
export var encrypt = function (data, keyStr) { return __awaiter(void 0, void 0, void 0, function () {
    var key, encrypted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('aes.encrypt');
                return [4 /*yield*/, aes.importKey(keyStr, { length: SymmKeyLength.B256 })];
            case 1:
                key = _a.sent();
                return [4 /*yield*/, aes.encryptBytes(data.buffer, key)];
            case 2:
                encrypted = _a.sent();
                return [2 /*return*/, new Uint8Array(encrypted)];
        }
    });
}); };
export var decrypt = function (encrypted, keyStr) { return __awaiter(void 0, void 0, void 0, function () {
    var key, decryptedBuf;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('aes.decrypt');
                return [4 /*yield*/, aes.importKey(keyStr, { length: SymmKeyLength.B256 })];
            case 1:
                key = _a.sent();
                return [4 /*yield*/, aes.decryptBytes(encrypted.buffer, key)];
            case 2:
                decryptedBuf = _a.sent();
                return [2 /*return*/, new Uint8Array(decryptedBuf)];
        }
    });
}); };
export var genKeyStr = function () { return __awaiter(void 0, void 0, void 0, function () {
    var key;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('aes.genKeyStr');
                return [4 /*yield*/, aes.makeKey({ length: SymmKeyLength.B256 })];
            case 1:
                key = _a.sent();
                return [2 /*return*/, aes.exportKey(key)];
        }
    });
}); };
export var decryptGCM = function (encrypted, keyStr, ivStr) { return __awaiter(void 0, void 0, void 0, function () {
    var iv, sessionKey, decrypted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('aes.decryptGCM');
                iv = utils.base64ToArrBuf(ivStr);
                return [4 /*yield*/, crypto.subtle.importKey("raw", utils.base64ToArrBuf(keyStr), "AES-GCM", false, ["encrypt", "decrypt"])
                    // Decrypt secrets
                ];
            case 1:
                sessionKey = _a.sent();
                return [4 /*yield*/, crypto.subtle.decrypt({
                        name: "AES-GCM",
                        iv: iv
                    }, sessionKey, utils.base64ToArrBuf(encrypted))];
            case 2:
                decrypted = _a.sent();
                return [2 /*return*/, utils.arrBufToStr(decrypted, CharSize.B8)];
        }
    });
}); };
export var sha256 = function (bytes) { return __awaiter(void 0, void 0, void 0, function () {
    var buf, hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('hash.sha256');
                buf = bytes.buffer;
                return [4 /*yield*/, crypto.subtle.digest('SHA-256', buf)];
            case 1:
                hash = _a.sent();
                return [2 /*return*/, new Uint8Array(hash)];
        }
    });
}); };
export var rsaVerify = function (message, signature, publicKey) {
    assertBrowser('rsa.verify');
    var keyStr = utils.arrBufToBase64(publicKey.buffer);
    return rsaOperations.verify(message, signature, keyStr);
};
export var ed25519Verify = function (message, signature, publicKey) {
    return ed25519.verify(signature, message, publicKey);
};
export var ksPublicReadKey = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.publicReadKey');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.publicReadKey()];
        }
    });
}); };
export var ksPublicWriteKey = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.publicWriteKey');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.publicWriteKey()];
        }
    });
}); };
export var ksDecrypt = function (encrypted) { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.decrypt');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.decrypt(encrypted)];
        }
    });
}); };
export var ksSign = function (message, charSize) { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.sign');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.sign(message, { charSize: charSize })];
        }
    });
}); };
export var ksImportSymmKey = function (key, name) { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.importSymmKey');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.importSymmKey(key, name)];
        }
    });
}); };
export var ksExportSymmKey = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.exportSymmKey');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.exportSymmKey(name)];
        }
    });
}); };
export var ksKeyExists = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.keyExists');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.keyExists(name)];
        }
    });
}); };
export var ksGetAlg = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertBrowser('keystore.getAlg');
                return [4 /*yield*/, keystore.get()];
            case 1:
                ks = _a.sent();
                return [2 /*return*/, ks.cfg.type];
        }
    });
}); };
export var ksClear = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        assertBrowser('keystore.clear');
        return [2 /*return*/, keystore.clear()];
    });
}); };
//# sourceMappingURL=browser.js.map